/**
 * Checks the current instance's token at 50-second intervals and dispatches an action to renew it whenever its
 * expiration UNIX timestamp comes within ten minutes of the current UNIX time.
 *
 * CP (Vue 3): these were `Vue.startAuthVerifier` / `Vue.stopAuthVerifier` statics installed by a Vue plugin.
 * Under Vue 3 `app.use(plugin)` calls `install(app)`, so the statics landed on the app instance, not on the
 * `Vue` compat global that the store modules import — `Vue.stopAuthVerifier` was therefore `undefined` and
 * `Store.logout` threw at boot. They touch only the store (never Vue), so they are plain module functions now;
 * `auth.js` imports them directly.
 */
import store from '@/store/store'

export function startAuthVerifier () {
  let authTimer = setInterval(() => {
    let requested = store.getters.renewalRequested
    const exp = parseFloat(store.getters.getActiveInstance.exp)
    const tenMinFromNow = (new Date().getTime() / 1000) + 600
    if (tenMinFromNow >= parseFloat(exp) && !requested) {
      store.dispatch('requestNewToken')
    }
  }, 50000)
  store.dispatch('setAuthVerificationTimer', authTimer)
}

export function stopAuthVerifier () {
  const timer = store.getters.getAuthVerificationTimer
  clearInterval(timer)
  store.dispatch('setAuthVerificationTimer', null)
}
